import React from 'react';
import {Link} from 'react-router-dom';

import styles from './styles.module.scss';
import {routes} from '../../constants/routes';
import {LogoComponent} from '../Logo';
import {socialLinks} from '../../constants/links';
import {Social} from '../../components/Social';

const themis = {
  title: 'Themis',
  links: [
    {
      id: '1',
      title: 'Twitter',
      href: socialLinks.twitter,
    },
    {
      id: '2',
      title: 'Discord',
      href: socialLinks.discord,
    },
    {
      id: '3',
      title: 'Support Server',
      path: routes.notification,
    },
  ],
};

const company = {
  title: 'Company',
  links: [
    {
      id: '1',
      title: 'Careers',
      path: routes.recovery,
      label: 'hiring',
    },
    {
      id: '2',
      title: 'Terms of Service',
      path: routes.recovery,
    },
    {
      id: '3',
      title: 'Privacy Policy',
      path: routes.recovery,
    },
    {
      id: '4',
      title: 'Contact',
      path: routes.recovery,
    },
  ],
};

const getLinks = (links) => {
  return links.map((link) => {
    if (link.path) {
      return (
        <Link key={link.id} className={styles.link} to={link.path}>
          {link.title}
          {link.label && <span className={styles.label}>{link.label}</span>}
        </Link>
      );
    }
    return (
      <a key={link.id} className={styles.link} href={link.href} target="_blank" rel="noreferrer">
        {link.title}
        {link.label && <span className={styles.label}>{link.label}</span>}
      </a>
    );
  });
};

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <>
      <div className={styles.decor}></div>
      <footer className={styles.footer}>
        <div className={styles.container}>
          <div className={styles.content}>
            <div className={styles.leftBlock}>
              <div className={styles.logoWrapper}>
                <LogoComponent />
                <p className={styles.logo}>Themis</p>
              </div>
              <div className={styles.socialWrapper}>
                <Social />
              </div>
              <div className={styles.copy}>
                &copy; Copyright {year} Alwond Limited. All rights reserved.
              </div>
            </div>
            <div className={styles.rightBlock}>
              <div className={styles.linksBlock}>
                <p className={styles.title}>{themis.title}</p>
                <div className={styles.links}>{getLinks(themis.links)}</div>
              </div>
              <div className={styles.linksBlock}>
                <p className={styles.title}>{company.title}</p>
                <div className={styles.links}>{getLinks(company.links)}</div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
